import { render, staticRenderFns } from "./lkuAdvset_db.1.vue?vue&type=template&id=f86524da"
import script from "./lkuAdvset_db.1.vue?vue&type=script&lang=js"
export * from "./lkuAdvset_db.1.vue?vue&type=script&lang=js"
import style0 from "./lkuAdvset_db.1.vue?vue&type=style&index=0&id=f86524da&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports